module.exports = __webpack_public_path__ + "img/kefu-ercode.ac3b9452.png";